<template>
    <div
        ref="contain"
        class="quickInput-card"
    >
        <div
            @click="leftRow(isPreview)"
            v-show="rowShow&&rowLeft"
            class="button-row row-left"
        >
            <v-icon remote name="arrow_left_small_line" />
        </div>
        <div
            ref="containInner"
            :style="{width: '100%', marginLeft: '0'}"
            class="card-box"
        >
            <v-dragarea
                ref="listBox"
                :value="list"
                @dragStart="dragStart"
                @dragEnd="dragEnd"
                :class="{'previewBox': isPreview}"
                layout="horizontal"
                use-rawdata
                class="listBox"
            >
                <v-drag-item
                    v-for="(item, i) of list"
                    :key="i"
                    :data="item"
                    :draggable="!isPreview"
                >
                    <v-tip
                        ref="statisfyTip"
                        kind="small"
                        placement="top"
                    >
                        <div>如关闭满意度设置，该气泡将不展示。</div>
                        <div>实际效果以线上体验为准。</div>
                    </v-tip>
                    <div
                        ref="listItem"
                        :class="{
                            'chose': choseIndex === i && isPreview === false,
                            'pointerPreview': isPreview,
                            'msgNull': item.error,
                        }"
                        @click="choseOne(i)"
                        class="list-msg"
                    >
                        <v-icon
                            @click.stop="delList(i)"
                            name="close"
                            class="close"
                        />
                        <div
                            :style="{
                                color: colorData.color,
                                ...((channelType !== 1 && colorData.borderAdaptTextColor) ? { borderColor: colorData.color } : {}),
                                ...(channelType === 1 ? { borderRadius: '15px' } : {}),
                            }"
                            class="list-msg-input"
                        >
                            {{ item.name?item.name: item.placeholder }}
                        </div>
                    </div>
                </v-drag-item>
                <div
                    ref="addItem"
                    v-show="addIconShow"
                    @click="addList"
                    class="list-add"
                >
                    <span>
                        <v-icon
                            name="new"
                            class="add"
                        />添加
                    </span>
                </div>
            </v-dragarea>
        </div>
        <div
            @click="rightRow(isPreview)"
            v-show="rowShow&&rowRight"
            class="button-row row-right"
        >
            <v-icon remote name="arrow_right_small_line" />
        </div>
        <v-dialog
            v-model="delDialog"
            @confirm="delConfirm"
            title="删除该按钮？"
            kind="confirm"
            status="warning"
        >
            <div>
                删除后，该按钮的名称和动作都将被清空
            </div>
            <span slot="confirm-text">删除</span>
        </v-dialog>
    </div>
</template>

<script>
import { resetMenuSNData } from '../../config';
import cloneDeep from 'lodash/cloneDeep';

const contentPadding = 18;
const moveBtnWidth = 28;
const defaultNavWidth = 76;
export default {
    name: 'Card',
    inject: ['channelType'],
    props: {
        value: {
            default() {
                return {
                    enableSwitch: true,
                    color: {},
                    menu: {},
                };
            },
        },
        isPreview: {
            type: Boolean,
            default: false,
        },
        max: {
            type: Number,
            default: 12,
        },
        // 当前选择的菜单
        currNavMenuIndex:{
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            widthTotal: 0,
            rowShow: false,
            rowLeft: false,
            rowRight: false,
            choseIndex: this.currNavMenuIndex,
            delDialog: false,
            mouseDown: false,
            oldListName: [],
            choseValue: 0,
            confirmData: false,
            addWidth: false,
            delWidth: false,
            srcVmDataValue: 0,
            previewTotal: 0,
            screenTotal: 1,
            marginNumber: [],
            contentWidth: 0,
            list: [],
            colorData: {},
        };
    },
    computed: {
        delIconShow() {
            return this.list.length > 1;
        },
        addIconShow() {
            return this.list.length < this.max && this.isPreview === false;
        },
    },
    watch: {
        // 处理索引值变化
        currNavMenuIndex(val) {
            this.choseIndex = val;
        },
        choseIndex(val) {
            this.$emit('update:currNavMenuIndex', val);
        },

        value: {
            handler(newVal, oldVal) {
                if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;
                this.parseData();
            },
            deep: true,
        },

        // 只监听list变化
        list: {
            handler(newList) {
                this.updateNav();
                this.$nextTick(() => {
                    this.getWidthAll();
                });
            },
            deep: true,
        },

        widthTotal: {
            handler(val, oldValue) {
                const listBox = this.isPreview ? document.getElementsByClassName('previewBox')[0] : document.getElementsByClassName('listBox')[0];
                // 导航总长在可视范围内，不移动
                if (val <= this.$refs.contain.offsetWidth) {
                    listBox.style.marginLeft = 0;
                    this.rowLeft = false;
                    this.rowRight = false;
                    this.initWidthStatus();
                    return;
                }
                let move = val - this.$refs.containInner.offsetWidth + contentPadding; // contain padding大小
                const listItems = this.$refs.listItem || [];
                const marginLeft = - listBox.style.marginLeft.replace('px', '');
                const scrollRight = Math.abs(oldValue - marginLeft - this.$refs.containInner.offsetWidth);
                // 添加时，永远右对齐
                if (this.addWidth) {
                    if (!this.rowLeft) {
                        move = move + moveBtnWidth;
                    }
                    this.rowLeft = true;
                    this.rowRight = false;
                    // if(listItems.length === this.max - 1 && !this.addIconShow){
                    //     // 添加到最后一个时，添加按钮消失
                    //     move = move + this.$refs.addItem.offsetWidth
                    // }
                    listBox.style.marginLeft = `${-move}px`;
                    this.initWidthStatus();
                    return;
                }
                // 删除
                if (this.delWidth) {
                    // 左对齐，或可视区在导航条中间
                    if (scrollRight > defaultNavWidth) {
                        this.rowRight = true;
                        return;
                    }
                    // 右对齐，保持
                    listBox.style.marginLeft = `${-move}px`;
                    this.rowRight = false;
                    this.initWidthStatus();
                    return;
                }

                // 编辑导航名称引发长度变化
                if (!this.delWidth && !this.delWidth) {
                    // 左对齐，或可视区在导航条中间
                    if (scrollRight > defaultNavWidth) {
                        this.rowRight = true;
                        return;
                    }
                    // 右对齐，保持；考虑在输入名称的时候会引起宽度的变化，把内容挤出去
                    listBox.style.marginLeft = `${-move}px`;
                    this.rowLeft = true;
                    return;
                }
            },
            deep: true,
        },

        isPreview(val) {
            this.getWidthAll();
            this.$nextTick(() => {
                document.getElementsByClassName('previewBox')[0].style.marginLeft = '0px';
            });
        },
    },
    created() {
    },
    mounted() {
        this.parseData();
        // 这个不能少，否则PC/Mobile切换时会丢失左右滚动按钮
        this.$nextTick(() => { this.getWidthAll(); });
    },
    methods: {
        parseData() {
            console.log('[card][parseData]');
            // 只处理color, menu;
            const { color = {}, menu = {} } = this.value;

            if (typeof (color.value) !== undefined) {
                this.colorData = cloneDeep(color);
            }

            if (menu.list) {
                this.list = cloneDeep(menu.list);
            }
        },

        /** 更新数据 */
        updateNav() {
            console.log('[card][updateNav]');
            const data = {
                ...this.value,
                menu: {
                    list: cloneDeep(this.list),
                },
            };

            // 数据检查，防止死循环。
            if (JSON.stringify(data) === JSON.stringify(this.value)) {
                console.log('[card][updateNav] not change');
                return;
            }

            this.$emit('input', data);
            this.$emit('change', data);
        },

        getWidthAll() {
            const item = this.$refs.listItem;
            const width = [];
            let result = 0;
            for (let i = 0; i < item.length; i++) {
                width[i] = item[i].clientWidth;
                result += width[i];
            }
            this.widthTotal = this.addIconShow ? (result + this.$refs.addItem.offsetWidth) : result;
            this.rowShow = this.widthTotal > this.$refs.contain.offsetWidth;
        },
        rightRow(isPreview) {
            const listBox = isPreview ? document.getElementsByClassName('previewBox')[0] : document.getElementsByClassName('listBox')[0];
            const listBoxMarginLeft = -listBox.style.marginLeft.replace('px', '');
            const containInnerWidth = this.$refs.containInner.offsetWidth;
            const item = [...this.$refs.listItem];
            const width = [];
            let result = 0;
            if (item.length < this.max) {
                item.push(this.$refs.addItem);
            }
            for (let i = 0; i < item.length; i++) {
                width[i] = item[i].clientWidth;
                result += width[i];
                if (result - listBoxMarginLeft > containInnerWidth) {
                    result = result - width[i];
                    const rest = this.widthTotal - result;
                    const addBtnWidth = isPreview ? 0 : this.$refs.addItem.offsetWidth;
                    const compareWidth = i === item.length - 1 ? containInnerWidth + addBtnWidth : containInnerWidth;
                    if (rest > compareWidth) {
                        listBox.style.marginLeft = `${-(result - 10)}px`;
                        this.rowRight = true;
                        this.rowLeft = true;
                    } else {
                        listBox.style.marginLeft = `${-(this.widthTotal - containInnerWidth + 20)}px`;
                        this.rowRight = false;
                        this.rowLeft = true;
                    }
                    break;
                }
            }
        },
        leftRow(isPreview) {
            const listBox = isPreview ? document.getElementsByClassName('previewBox')[0] : document.getElementsByClassName('listBox')[0];
            const containInnerWidth = this.$refs.containInner.offsetWidth;
            const marginLeft = -listBox.style.marginLeft.replace('px', '');
            const item = [...this.$refs.listItem];
            const width = [];
            let result = 0;
            if (item.length < this.max) {
                item.push(this.$refs.addItem);
            }
            for (let i = item.length - 1; i >= 0; i--) {
                width[i] = item[i].clientWidth;
                result += width[i];
                const addBtnWidth = isPreview ? 0 : this.$refs.addItem.offsetWidth;
                const compareWidth = i === item.length - 1 ? containInnerWidth + addBtnWidth : containInnerWidth;
                const moved = this.widthTotal - marginLeft - containInnerWidth;
                if (result - moved >= containInnerWidth) {
                    result = result - width[i] - moved;
                    if (marginLeft  > containInnerWidth) {
                        listBox.style.marginLeft = `${-(marginLeft - result)}px`;
                        this.rowRight = true;
                        this.rowLeft = true;
                    } else {
                        listBox.style.marginLeft = '0px';
                        this.rowRight = true;
                        this.rowLeft = false;
                    }
                    break;
                }
            }
        },
        dragStart(srcVmData) {
            this.srcVmDataValue = srcVmData.value;
        },
        dragEnd() {
            for (let i = 0; i < this.list.length; i++) {
                if (this.srcVmDataValue === this.list[i].value) {
                    this.choseOne(i);
                    break;
                }
            }

            resetMenuSNData(this.list);
        },
        delConfirm() {
            this.delMethod(this.delDialogIndex);
        },
        delMethod(index) {
            this.$emit('deleteOne', index);
            this.$nextTick(() => {
                const maxIndex = this.list.length - 1;
                // 如果删除后选中项超过列表长度，就选中最后一个。
                if (this.choseIndex > maxIndex) {
                    // 选中最后一个
                    this.choseOne(maxIndex);
                } else {
                    this.choseOne(this.choseIndex);
                }
            });
        },
        delList(index) {
            this.delDialogIndex = index;
            this.delDialog = true;
            // 触发删除操作的时候，选中该按钮。因为删除的时候会有一个选中效果，如果不真实选中，会导致选中效果不准确。
            this.choseOne(index);
        },
        addList() {
            this.$emit('addOne');
            this.$nextTick(() => {
                // 选中最后一个
                this.choseOne(this.list.length - 1);
            });
        },
        choseOne(i) {
            this.choseIndex = i;
        },
        initWidthStatus() {
            this.delWidth = false;
            this.addWidth = false;
        },

        // 滚动到元素到可见区域
        scrollToElementIfNotInView() {
            const element = this.$refs.listItem[this.choseIndex];
            const parent = this.$refs.containInner;
            if (element) {
                const rect = element.getBoundingClientRect();
                const parentRect = parent.getBoundingClientRect();
                // 检查元素是否在父容器的可见区域
                if (rect.left < parentRect.left) {
                    this.leftRow(this.isPreview);
                }
                if (rect.right > parentRect.right) {
                    this.rightRow(this.isPreview);
                }
            }
        },
    },
};
</script>

<style lang="less">
@import './index.less';
</style>
